// Track Giving Form Block form submissions
jQuery( document ).ready( function ( $ ) {
	jQuery( '.giving-form__form-element' ).on( 'submit', function () {
		if ( typeof window.ncst != 'object' ) return;

		var label = $( this ).attr( 'action' );
		var value = $( this ).find( '.giving-form__input' ).val();
		window.ncst.controllers.analytics.broadcastEvent( 'ncst.formSubmit', {
			category: 'Giving Form Block',
			action: 'Form Submit',
			label: label,
			value: value,
		} );
	} );
} );
